(ns app.front.view.landing-page-subs
  "Subscriptions for landing page data that are shared across namespaces.
  Kept separate to avoid circular dependencies (e.g. call-to-action
  needs ::calls-to-action without pulling in the full landing-page view ns)."
  (:require [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::calls-to-action
  (fn [db _]
    (-> db
        :app.front.view.landing-page/landing-config
        :calls-to-action)))

(rf/reg-sub ::contact-request-enabled?
  (fn [db _]
    (-> db
        :app.front.view.landing-page/landing-config
        :contact-request?)))
